var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransaction(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E8EAF0",
    d: "M162.5,108.2c-3.2,0-5.9,2.6-5.9,5.9v33.2H139c-3.2,0-5.9,2.6-5.9,5.9s2.6,5.9,5.9,5.9h23.4 c3.2,0,5.9-2.6,5.9-5.9v-39.1C168.4,110.8,165.7,108.2,162.5,108.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8EAF0",
    d: "M37.5,91.8c3.2,0,5.9-2.6,5.9-5.9V52.7H61c3.2,0,5.9-2.6,5.9-5.9c0-3.3-2.7-5.8-6-5.8H37.5 c-3.2,0-5.9,2.6-5.9,5.9V86C31.6,89.2,34.3,91.8,37.5,91.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8EAF0",
    d: "M115.2,141.4H95.7c-6.5,0-11.7,5.2-11.7,11.7s5.2,11.7,11.7,11.7h19.5c3.2,0,5.9-2.6,5.9-5.9v-11.7 C121.1,144,118.5,141.4,115.2,141.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8EAF0",
    d: "M72.3,153.1c0-12.9,10.5-23.4,23.4-23.4h17.6v-5.9c0-9.7-7.9-17.6-17.6-17.6H17.6 c-9.7,0-17.6,7.9-17.6,17.6v58.6c0,9.7,7.9,17.6,17.6,17.6h78.1c9.7,0,17.6-7.9,17.6-17.6v-5.9H95.7 C82.8,176.6,72.3,166,72.3,153.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8EAF0",
    d: "M194.1,35.2h-19.5c-6.5,0-11.7,5.2-11.7,11.7s5.2,11.7,11.7,11.7h19.5c3.2,0,5.9-2.6,5.9-5.9V41 C200,37.8,197.4,35.2,194.1,35.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8EAF0",
    d: "M151.2,46.9c0-12.9,10.5-23.4,23.4-23.4h17.6v-5.9c0-9.7-7.9-17.6-17.6-17.6H96.5 c-9.7,0-17.6,7.9-17.6,17.6v58.6c0,9.7,7.9,17.6,17.6,17.6h78.1c9.7,0,17.6-7.9,17.6-17.6v-5.9h-17.6 C161.7,70.3,151.2,59.8,151.2,46.9z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransaction);
export default __webpack_public_path__ + "static/media/transaction.50f4faa9740eaacd1eaf295eb45897c8.svg";
export { ForwardRef as ReactComponent };